import { render, staticRenderFns } from "./RiskSurveyFireAttch.vue?vue&type=template&id=2387671e&"
import script from "./RiskSurveyFireAttch.vue?vue&type=script&lang=js&"
export * from "./RiskSurveyFireAttch.vue?vue&type=script&lang=js&"
import style0 from "./RiskSurveyFireAttch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports